import { useQuery } from '@tanstack/react-query';
import { generateTenantSearchKey } from 'src/api/lib/meilisearch';
import { tenantMeilisearchSearchKeyKeys } from 'src/api/query-keys/tenant/meilisearch-search-key';
import { useUserStore } from 'src/store/user-store';

export const useGenerateTenantSearchKey = (enabled = true) => {
  const { directoryToken } = useUserStore();

  return useQuery({
    queryFn: generateTenantSearchKey,
    queryKey: tenantMeilisearchSearchKeyKeys.detail(directoryToken ?? ''),
    enabled,
  });
};
